export default __webpack_public_path__ + "static/media/591.41e8d500.jpg";